export default class FileNode {
  type: 'file' | 'folder';
  file: File;
  children: FileNode[];

  constructor({ type, file, children }) {
    this.type = type;
    this.file = file;
    this.children = children;
  }
}
